import axios, { AxiosRequestConfig, AxiosResponse } from "axios";

export const fetcher = <T = any>(url: string) =>
  axios.get<T, AxiosResponse<T>, never>(url).then((response) => response.data);

export const fetcherWithOptions = <T = any, D = any>([url, options]: [
  string,
  AxiosRequestConfig<D>
]) => axios.get<T, AxiosResponse<T>, D>(url, options).then((response) => response.data);
